module.exports = __webpack_public_path__ + "static/media/afplogo.61fe38ed.png";